import React, { useState, useEffect } from 'react';
import './ShippingForm.css';
import CustomerInfo from './CustomerInfo/CustomerInfo';
import ShippingInfo from './ShippingInfo/ShippingInfo';
import PaymentInfo from './PaymentInfo/PaymentInfo';
import InvoiceInfo from './InvoiceInfo/InvoiceInfo';
import { useOrderContext } from '../../Context/OrderContext';

const ShippingForm = ({ setShippingMethod, setShippingFee, onShippingFeeChange, activeTab, setActiveTab }) => {
    const { formData, setFormData, shippingFee } = useOrderContext(); // Access formData from context


    // Whenever shipping method or fee changes, recalculate
    useEffect(() => {
        // Notify the parent component about the changes
        if (onShippingFeeChange) {
            onShippingFeeChange(formData.shippingMethod, shippingFee); // This is the function from CartPage
        }
    }, [shippingFee, formData.shippingMethod, onShippingFeeChange]);

    const updateShippingFee = (method, fee) => {
        setFormData((prevData) => ({
            ...prevData,
            shippingMethod: method,
            shippingFee: fee,
        }));
    };

    const handleContinue = () => {
        if (activeTab === 'customer-info') {
            setActiveTab('shipping-info');
        } else if (activeTab === 'shipping-info') {
            setActiveTab('payment-info');
        } else if (activeTab === 'payment-info') {
            setActiveTab('invoice-info'); // After payment, show invoice info
        } else if (activeTab === 'invoice-info') {
            alert('Your order has been placed!'); // Finalize the order here
        }
    };

    const handleBack = () => {
        if (activeTab === 'shipping-info') {
            setActiveTab('customer-info');
        } else if (activeTab === 'payment-info') {
            setActiveTab('shipping-info');
        } else if (activeTab === 'invoice-info') {
            setActiveTab('payment-info'); // Go back to payment info from invoice
        }
    };

    return (
        <div className={`shipping-form ${activeTab === 'invoice-info' ? 'invoice-info-active' : ''}`}>
                {activeTab !== 'invoice-info' && (
                        <>
                            <div className="tabs">
                                <span className={`tab ${activeTab === 'customer-info' ? 'active' : ''}`}>01 CUSTOMER INFO</span>
                                <span className={`tab ${activeTab === 'shipping-info' ? 'active' : ''}`}>02 SHIPPING INFO</span>
                                <span className={`tab ${activeTab === 'payment-info' ? 'active' : ''}`}>03 PAYMENT SELECTION</span>
                            </div>

                            {activeTab === 'customer-info' && (
                                <CustomerInfo
                                    onContinue={handleContinue}
                                    onBack={handleBack}
                                />
                            )}
                            {activeTab === 'shipping-info' && (
                                <ShippingInfo
                                    onContinue={handleContinue}
                                    onBack={handleBack}
                                    setShippingMethod={updateShippingFee} // Pass handler to update method and fee
                                    onShippingFeeChange={onShippingFeeChange} // Pass this prop to ShippingInfo to update parent
                                    updateFormData={setFormData} // Pass setFormData function to ShippingInfo
                                />
                            )}
                            {activeTab === 'payment-info' && (
                                <PaymentInfo
                                    onContinue={handleContinue}
                                    onBack={handleBack}
                            />
                        )}
                    </>
                )}
                
                {activeTab === 'invoice-info' && (
                    <InvoiceInfo
                        setShippingMethod={updateShippingFee}
                    />
                )}
        </div>
    );
};

export default ShippingForm;
